<template>
  <div class="main-container" style="margin: 20px auto">
    <div class="bi-title">关于我们</div>
    <div class="card-head-line"></div>
    <div v-if="this.userPlatform === 2" class="card-module-container">
      <div class="card-half-item card-cover-item">
        <div class="card-box" v-html="aboutUsInfo.briefHtml"></div>
      </div>

      <div class="card-half-item card-cover-item card-cover-img-item">
        <div class="card-box">
          <div class="card-cover-img"></div>
          <!-- <img class="card-cover-img" src="../assets/home/class.png" /> -->
        </div>
      </div>
    </div>

    <div
      v-if="this.userPlatform !== 2"
      class="card-module-container"
      @click="moreTextClick"
    >
      <div class="card-half-item card-cover-item">
        <div
          class="responsive-card-box"
          v-html="aboutUsInfo.briefHtml"
          :style="moreHeightStyle"
        ></div>
        <div class="btn-more">
          <!-- {{ moreTextIsOpen }} -->
          {{ moreText }}
          <img
            :class="['btn-more-arrow', arrowIconClass]"
            src="../assets/images/register/arrow-right.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div v-if="this.userPlatform !== 2" class="card-module-container">
      <div class="card-half-item card-height-auto-item">
        <div class="bi-title">公司地址</div>
        <div class="card-head-line"></div>
        <div class="card-box">
          <div class="card-list">
            <div class="card-list-item">
              <div class="card-list-label">总部地址:</div>
              <div class="card-list-content">
                北京市东城区东直门外大街39号院2号楼 航空服务楼5层501A
              </div>
            </div>

            <div class="card-list-item">
              <div class="card-list-label">邮箱地址:</div>
              <div class="card-list-content">xwg@baiinfo.com</div>
            </div>

            <div class="card-list-item">
              <div class="card-list-label">联系方式:</div>
              <div class="card-list-content">18618300427</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      // 关于我们
      aboutUsInfo: {
        briefHtml: `
<p>百川盈孚（www.baiinfo.com）是中国大宗商品市场信息供应商之一，以专业、迅捷的信息服务获得广大市场参与者的认可。每日跟踪报道产品价格行情动态，综合上下游深入研究产业发展，预测行业未来走向、投资方向及前景，为客户提供市场决策的资讯。</p><p><br></p><p>网站为企业生产经营生态价值链提供以原材料、制成品现货价格与市场分析预测及市场研究为核心的市场咨询服务。信息涉及能源、化工、农化、煤化工、橡塑、聚氨酯、农业、钢铁、有色、非金建材、纸品、新材料等100个产业链，700多个垂直行业频道，每日更新1000多种大宗商品海量资讯。</p><p><br></p><p>百川盈孚一直秉承中立的原则，以用户价值为依归，为客户提供产业链信息，专业的行业分析报告，丰富多样的信息服务模式。除提供网站信息浏览、行业大数据智能分析系统外，还为客户提供包括定制报告、调研报告、手机APP、数据库查询、会议及会展、网络广告等一系列信息咨询服务。</p><p><br></p><p>北京百川盈孚科技有限公司总部位于北京，在天津、成都、上海设立分支机构，并在沈阳、西安、南昌设立子公司，公司为国家高新技术企业。2007年成立发展至今，已经拥有了一支包含众多资深编辑及优秀分析师的专业团队，现有员工700余人，其中80%左右的员工拥有本科及以上学历。</p>
        `,
        img: "",
      },
      moreTextIsOpen: false,
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    moreText() {
      if (this.moreTextIsOpen) {
        return "收起";
      }
      return "查看更多";
    },
    moreHeightStyle() {
      if (this.moreTextIsOpen) {
        return {
          height: "420px",
        };
      }
      return {
        height: "190px",
      };
    },
    arrowIconClass() {
      if (this.moreTextIsOpen) {
        return "arrow-up";
      }
      return "";
    },
  },
  methods: {
    moreTextClick() {
      this.moreTextIsOpen = !this.moreTextIsOpen;
      // debugger
    },
  },
};
</script>

<style lang="scss" scoped >
.card-module-container {
  // width: 1200px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 12px;
  overflow: hidden;

  .card-half-item {
    width: 100%;
    padding: 10px 0;
    transition: all 250ms ease-in-out;

    .responsive-card-box {
      position: relative;
      padding: 10px 0;
      transition: all 250ms ease-in-out;

      // height: 180px;
    }
    .btn-more {
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      height: 25px;
      padding-top: 5px;
      background: linear-gradient(to bottom, #ffffff5a, #ffffff);

      .btn-more-arrow {
        width: 2em;
        height: 1em;
        object-fit: contain;
        transition: all 200ms ease-in-out;
      }
      .arrow-up {
        transform: rotate(90deg);
      }
    }

    .card-box {
      height: 402px;
      overflow: hidden;
      border: 1px solid #dcdfe6;
      padding: 10px 0;
      .card-list {
        padding: 20px;
        .card-list-item {
          display: flex;
          flex-wrap: nowrap;
          // height: 2rem;
          // line-height: 2rem;

          
          font-weight: 400;
          color: #333333;

          .card-list-label {
            min-width: 5em;
            width: 5em;
          }
          .card-list-content {
            flex-basis: 1;
            flex-grow: 1;
          }
        }
      }
    }
  }
  .card-cover-item {
    position: relative;
    padding-top: 0;
    .card-box {
      border-width: 0;
      height: auto;
      font-size: 12px;
      color: #333333;
      .card-cover-img {
        width: 100%;
        height: 100%;
        background: url(../assets/home/class.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
  }
  .card-cover-img-item {
    display: none;
  }
  .card-height-auto-item {
    .card-box {
      background: url(../assets/home/addressbg.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      height: auto;
    }
  }
}
@media (min-width: 1280px) {
  .card-module-container {
    width: 1200px;
    padding: 10px 0;

    .card-half-item {
      min-width: 590px;
      width: 590px;
      padding: 0;

      .card-box {
        .card-list {
          padding: 20px;
          .card-list-item {
            font-size: 1.2rem;
            .card-list-label {
              min-width: 5em;
              width: 5em;
            }
          }
        }
      }
    }
    .card-cover-item {
      padding-top: 10px;
      .card-box {
        height: 280px;
      }
    }
    .card-cover-img-item {
      display: block;
    }
  }
}
</style>